const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان محصول',
    },
    barcode: {
      type: 'string',
      title: 'بارکد',
    },
    category_id: {
      type: 'string',
      title: 'دسته بندی',
    },
    brand_id: {
      type: 'string',
      title: 'برند',
    },
    introtext: {
      type: 'string',
      title: 'توضیحات',
    },
  },
});

export default schema;
